import Vue from 'vue';
import VueRouter from 'vue-router';
import SentryPlugin from '~vue/plugins/sentry';
import { i18nMixin, registerLanguages } from '@wealthbar/i18n';
import changeLanguage from '@wealthbar/i18n/dist/change_language';

import locale from '~utils/locale';
import processLabels from '~utils/process-labels';

import index from './public.vue';

import about from './pages/about';
import investments from './pages/investments';

Vue.use(VueRouter);
Vue.use(SentryPlugin);
Vue.mixin(i18nMixin);

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/about', name: 'about', component: about },
    { path: '/investments', name: 'index', component: investments },
  ],
});

registerLanguages({
  'fr-CA': async () => {
    const lang = await import('~locale/fr_CA/wealthbar-app.po');
    return processLabels(lang);
  },
});

const language = locale.isFrench() ? 'fr-CA' : 'en';

/* eslint no-new: "off" */
changeLanguage(language).then(() => {
  new Vue({
    el: '#app',
    router,
    render(h) { return h(index); },
  });
});
